<template>
  <v-data-table
      :items="discountCodeUsages.items"
      :loading="isLoading"
      :disable-initial-sort="true"
      :total-items="total"
      :no-data-text="trans('app.search.no_data')"
      :headers="headers"
      :pagination.sync="pagination"
  >
    <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
    <template #items="props">
      <tr>
        <td>{{ `${props.item.user.email} (${props.item.user.first_name} ${props.item.user.last_name})` }}</td>
        <td>{{ `${props.item.discount_code.name} (${props.item.discount_code.code}) ${props.item.discount_code.value}${props.item.discount_code.type === 'fixed' ? ' zł' : '%'}` }}</td>
        <td>{{ 'app.id' | trans }}{{ `: ${props.item.order.id} ${props.item.order.subscription_type} ` }}{{props.item.order.amount | money}}</td>
        <td>{{ props.item.created_at }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import {trans} from "../../app";
import {mapActions, mapGetters} from "vuex";

export default {
  data: function () {
    return {
      isLoading: true,
      headers: [
        {
          text: trans('app.discount_codes.user'),
          align: 'left',
          sortable: false,
        },
        {
          text: trans('app.discount_codes.discount_code'),
          align: 'left',
          sortable: false,
        },
        {
          text: trans('app.discount_codes.order'),
          align: 'left',
          sortable: false,
        },
        {
          text: trans('app.createdAt'),
          align: 'left',
          value: 'created_at',
          sortable: true,
        },
      ],
      total: 0,
      pagination: {
        rowsPerPage: 50,
        sortBy: 'created_at',
        descending: true,
      },
    };
  },
  computed: {
    ...mapGetters(['discountCodeUsages']),
  },
  methods: {
    ...mapActions(['fetchDiscountCodeUsages']),
    async fetchData() {
      this.isLoading = true;
      const {sortBy, descending, page, rowsPerPage} = this.pagination;

      const query = {
        page: page,
        perPage: rowsPerPage,
        orderBy: sortBy,
        dir: descending ? 'desc' : 'asc',
      };

      await this.fetchDiscountCodeUsages(query);

      this.total = this.discountCodeUsages.total;
      this.pages = this.discountCodeUsages.last_page;
      this.isLoading = false;
    }
  },
  watch: {
    pagination: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
  },
}
</script>

<style scoped>

</style>
